import punycode from 'punycode';

/**
 * Unicode → Punycode (IDNA ASCII)
 */
export function toPunycode(host: string): string {
  try {
    return punycode.toASCII(host.trim());
  } catch {
    return host;
  }
}

/**
 * Punycode → Unicode.
 * Accepts either a hostname or a full URL. If it's a URL, only hostname is decoded
 * and the URL is reconstructed with the decoded hostname preserved.
 */
export function toUnicode(input: string): string {
  try {
    // If the string is percent-encoded (e.g., produced by encodeURIComponent), decode it first
    const decoded = safeDecode(input);

    // Try to parse as a full URL
    try {
      const url = new URL(decoded);
      const unicodeHost = punycode.toUnicode(url.hostname);
      // rebuild URL using decoded host and original parts
      return `${url.protocol}//${unicodeHost}${url.port ? `:${url.port}` : ''}${url.pathname}${url.search}${url.hash}`;
    } catch {
      // Not a URL, treat as hostname (may include path if user passed only host)
      return punycode.toUnicode(decoded.trim());
    }
  } catch {
    return input;
  }
}

// Safely decode a possibly percent-encoded string. If decoding fails, return the original.
function safeDecode(value: string): string {
  try {
    // decodeURIComponent will throw if value contains malformed sequences; also handle fully encoded full URLs
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}
